<template>
    <div class="form-group">
        <label for="exampleFormControlInput1">Font awesome icon :</label>
        <input ref="picker" v-model="search" @blur="blur" @focus="focus" type="email" class="form-control" id="exampleFormControlInput1" placeholder="Search an icon">
        <transition name="icon-preview-fade">
        <div v-if="focusOn" class="preview-container">
            <div @click="select(undefined)" @mouseover="hoverPanel = true" @mouseout="hoverPanel = false" :class="['previewer', 'rounded', {'shadow-sm': !hoverPanel}, {'shadow-sm': hoverPanel} ]">
                <div v-for="(i, index) in iconsFiltered" :key="index" class="icon-preview">
                    <div @click.prevent.stop="select(i)" :class="['icon-wrapper','rounded','shadow-sm', {selected: i.title == selected}]" >
                        <i :class="i.title" />
                    </div>
                </div>
            </div>
        </div>
        </transition>
    </div>
</template>

<script>
let timeout = undefined;

import {icons} from "./icons.js";

export default {
    name: 'FontawesomePicker',
    props: ['value'],
    data: function () {
        return {
            focusOn: true, // <- set this to false
            icons: icons,
            hoverPanel: false,
            search: "",
            beforeSelect: "",
            selected: "" };

    },
    beforeMount() {
        this.search = this.value;
    },
    watch: {
        search: function (newValue) {
            this.$emit('input', newValue);
        } },

    methods: {
        blur() {
            timeout = setTimeout(() => {
                this.focusOn = false;
            }, 150);
        },
        focus() {
            this.focusOn = true;
        },
        select(icon) {
            clearTimeout(timeout);
            if (icon) {
                if (this.search != this.selected) this.beforeSelect = this.search;
                this.selected = icon.title;
                this.search = icon.title;
            }
            this.$refs.picker.focus();
        } },

    computed: {
        iconsFiltered: function () {
            const search = this.search == this.selected ? this.beforeSelect : this.search;
            return this.icons.filter((i) =>
                i.title.indexOf(search) !== -1 || i.searchTerms.some(t => t.indexOf(search) !== -1));

        } } };
</script>

<style scoped lang="scss">
.icon-preview-fade-enter-active, .icon-preview-fade-leave-active {
    transition: opacity .25s;
}
.icon-preview-fade-enter, .icon-preview-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

.preview-container{
    width: 100%;
    position: relative;
}
.previewer{
    position: absolute;
    width: 100%;
    min-height: 50px;
    max-height: 500px;
    overflow: auto;
    background: white;
    top: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
}

.icon-preview{

    width: 20%;
    padding-top: 20%;
    position: relative;

    @media (max-width: 800px) {
        width: 33%;
        padding-top: 33%;
    }

    .icon-wrapper{
        position: absolute;
        height: 80%;
        width: 80%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items:center;
        cursor: pointer;
        transition: ease-in-out all .25s;

        &:hover, &.selected{
            background: #42b883;
            color: #fbfbfb;
        }

        i {
            font-size: 4vw;
        }
    }
}
</style>
